import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';

import Config from '../lib/config';

export type Selection = Record<string, '*' | string[]>;

export function useSelectedClients(): [
  Selection | undefined,
  (selection: Selection | null | undefined) => void,
] {
  const { push } = useHistory();
  const location = useLocation<Record<string, Selection | undefined>>();

  const currentClientSelection =
    (location.state && location.state[Config.queryParameters.ClientFilter]) ||
    undefined;

  const setSelectedClients = useCallback(
    (clientSelection: Selection | null | undefined) => {
      push({
        ...location,
        state: {
          ...location.state,
          [Config.queryParameters.ClientFilter]: clientSelection ?? undefined,
        },
      });
    },
    [location, push],
  );

  return [currentClientSelection, setSelectedClients];
}
